import styled from "styled-components";
import ButtonComponent from "../Button/Button";

export const Button = styled(ButtonComponent)`
  font-weight: normal;
`;

export const ButtonLink = styled.a`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 10px;
`;
